/**
 * ステータスバッジコンポーネント
 */

import type { ContactStatus } from "@repo/types";
import { CONTACT_STATUS_LABELS } from "@repo/types";
import { CheckCircle2, Circle, Eye } from "lucide-react";

interface StatusBadgeProps {
  status: ContactStatus;
  size?: "sm" | "md";
}

const STATUS_STYLES: Record<ContactStatus, string> = {
  pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
  reviewed: "bg-blue-100 text-blue-800 border-blue-200",
  resolved: "bg-green-100 text-green-800 border-green-200",
};

const STATUS_ICONS: Record<ContactStatus, React.ReactNode> = {
  pending: <Circle className="h-3 w-3" />,
  reviewed: <Eye className="h-3 w-3" />,
  resolved: <CheckCircle2 className="h-3 w-3" />,
};

export function StatusBadge({ status, size = "md" }: StatusBadgeProps) {
  const sizeClasses = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${STATUS_STYLES[status]} ${sizeClasses}`}
    >
      {STATUS_ICONS[status]}
      {CONTACT_STATUS_LABELS[status]}
    </span>
  );
}
